import { useNavigate, useSearchParams, useParams, useLocation, /* other hooks */ } from 'react-router-dom'; 

const withRouter = WrappedComponent => props => {
  const navigate = useNavigate();
  const params  = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  // other hooks

  return (
    <WrappedComponent
      {...props}
      params={params}
      location={location}
      navigate={navigate}
      searchParams={searchParams}
      setSearchParams={setSearchParams}
    />
  );
};

export default withRouter;